export default __webpack_public_path__ + "static/media/dragon-eggs.7e35f07d.jpg";